/* eslint-disable react/no-array-index-key */
import styled from "@emotion/styled";
import { TFunctionDetailedResult } from "i18next";
import React from "react";
import { isInsideNoomWebView } from "src/pageDefinitions/goto/utils";

const LinkText = styled.span`
  color: -webkit-link;
  cursor: pointer;
  text-decoration: underline;
`;

export type TranslatedParts = ({ link: string; linkText: string } | string)[];

export default function RichText({
  translatedParts,
  className,
  linkProps,
}: {
  translatedParts:
    | TranslatedParts
    | TFunctionDetailedResult<TranslatedParts, any>;
  className?: string;
  linkProps?: React.AnchorHTMLAttributes<HTMLAnchorElement>;
}) {
  const handleClick = (link: string) => {
    const deeplink = `${link}?openInExternalApp=true`;
    window.open(deeplink, "_system");
  };
  const parts = Array.isArray(translatedParts)
    ? translatedParts
    : translatedParts.res;
  return (
    <p className={className}>
      {parts.map((part, idx) => {
        if (typeof part === "object") {
          return isInsideNoomWebView() ? (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
            <LinkText
              key={idx}
              onClick={() => handleClick(part.link)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleClick(part.link);
                }
              }}
            >
              {part.linkText}
            </LinkText>
          ) : (
            // eslint-disable-next-line react/jsx-props-no-spreading
            <a key={idx} href={part.link} {...linkProps}>
              {part.linkText}
            </a>
          );
        }
        return <span key={idx}>{part}</span>;
      })}
    </p>
  );
}
